/* eslint-disable jsx-a11y/anchor-is-valid */
import React      from 'react';
import classnames from 'classnames';
import Tooltip    from './Tooltip';
import Label      from './Label';

class FileComponent extends React.Component {
  constructor(props) {
    super(props);
    this.uploadFile = this.uploadFile.bind(this);
    this.renderLabel = this.renderLabel.bind(this);

    this.state = {
      fileName: this.props.fileName,
    };
  }

  /**
   * callback function when the user press browse button
   * @param {*} event
   */
  uploadFile(event) {
    const file = event.target.files[0];
    const fileName = file ? file.name : '';
    this.setState({ fileName });
    this.props.onChangeParameter(this.props.name, fileName);
  }

  renderLabel() {
    if (this.props.label === null || this.props.label === '') {
      return null;
    }
    return (
      <Label
        label={this.props.label}
        required={this.props.required}> <Tooltip id={`tooltip-${this.props.name}`} title={this.props.tooltip} />
      </Label>
    );
  }

  render() {
    // ignore-validate
    const inputClassName = classnames({
      'ignore-validate': !this.props.isFileRequired,
    }, this.props.inputClassName);
    return (
      <div className="file-input d-grid">
        {this.renderLabel()}
        <div className={this.props.btnClassName}>
          {this.props.text}
          <input
            id={this.props.inputId}
            type="file"
            className={inputClassName}
            name={`${this.props.groupName}[${this.props.name}]`}
            onChange={this.uploadFile} />
        </div>
        <div>{this.state.fileName}</div>
      </div>
    );
  }
}

FileComponent.defaultProps = {
  name     : 'filename',
  groupName: 'parameters',
  label    : 'FileComponent',
  text     : 'Upload File',
  fileName : '',
  inputId  : null,
  btnClassName: 'btn btn-secondary-clear btn-filename',
};

export default FileComponent;
